import { PackageProps } from '../../types/packages/PackageProps';
import { initialState } from './constants';

export const normalizeUserPackage = (
  userPackage?: Partial<PackageProps> | null,
): PackageProps => ({
  ...initialState.userPackage,
  ...userPackage,
  id: userPackage?.id ?? initialState.userPackage.id,
  company: userPackage?.company ?? '',
  document: userPackage?.document ?? '',
  description: userPackage?.description ?? '',
  project: userPackage?.project ?? '',
  createdAt: userPackage?.createdAt ?? '',
  updatedAt: userPackage?.updatedAt ?? '',
});
